import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';

import { authSelector } from '../../store';

export default function RequireAuth() {
  const location = useLocation();
  const { isLoggedIn } = useSelector(authSelector);

  if (!isLoggedIn) {
    return <Navigate replace to='/auth/sign_in' state={{ from: location }} />;
  }

  return <Outlet />;
}
